import { _t } from '../base'

function addNextPageToPagination() {
    const nextPage = $("[data-testid='linkNextPage']")

    if (nextPage.length) {
        const newNextPage = nextPage.clone()
        const lastPage = $(".pagination [data-testid='linkLastPage']")
        const nextPageNum = parseInt($('.current').text()) + 1

        if (lastPage.attr('href') === nextPage.attr('href')) {
            return
        }

        newNextPage.removeClass('next pagination-link')
        newNextPage.insertAfter('.pagination .current')
        newNextPage.text(nextPageNum)
    }
}
function categoryTextChanges() {
    $('.pagination-loader .btn').text(_t('category.loading'))
}
function categoryTop() {
    $('.category-title').prependTo('.category-perex')
}

function infiniteProductPageScroll() {
    const loadProductsButton = document.querySelector('.load-products')

    if (!loadProductsButton) return

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    loadProductsButton.click()
                }
            })
        },
        {
            rootMargin: '100px', // Start loading slightly before the button is visible
            threshold: 0,
        }
    )

    observer.observe(loadProductsButton)
}

function moveAddCategoryElements() {
    const middleBanners = $('footer .hp-middle-banners')

    $(middleBanners).insertBefore($('.custom-footer__newsletter'))
}

function categoryHeader() {
    $('#category-header').wrapAll('<div class="category-header-wrapper"</div>')
    $('.category-header-wrapper').prepend($('<div class = "filter-section availability-filter"></div>'))
    $('.category-header-wrapper').prepend($('#manufacturer-filter'))
    $("form[action='/action/ProductsListing/setStockFilter/']").prependTo('.availability-filter')

    $('.availability-filter').find('.filter-label').text(_t('category.availability'))

    $('#manufacturer-filter h4').on('click', function () {
        const $parent = $(this).parent()
        $parent.toggleClass('open')
    })
}

function handleContentLoaded() {
    moveAddCategoryElements()
    categoryTop()
    addNextPageToPagination()
    categoryTextChanges()
    infiniteProductPageScroll()
    categoryHeader()
}

export function initCategory() {
    handleContentLoaded()

    document.addEventListener('ShoptetDOMPageContentLoaded', async function () {
        handleContentLoaded()
    })

    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', () => {
        addNextPageToPagination()
        categoryTextChanges()
        infiniteProductPageScroll()
    })
}
